// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Team Page Styles */
.team-page {
  min-height: 100vh;
  background: #f8fafc;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
}

.team-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.back-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #3b82f6;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 2rem;
}

.back-arrow {
  font-size: 18px;
  font-weight: bold;
}

.back-button:hover {
  background: #2563eb;
  transform: translateY(-1px);
}

.team-content {
  background: white;
  border-radius: 12px;
  padding: 3rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
}

.team-content h1 {
  text-align: center;
  font-size: 2.75rem;
  font-weight: 700;
  background: linear-gradient(135deg, #1e293b 0%, #475569 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 1.5rem;
  letter-spacing: -0.02em;
}

.team-subtitle {
  text-align: center;
  font-size: 1.2rem;
  color: #64748b;
  max-width: 600px;
  margin: 0 auto 4rem;
  line-height: 1.7;
}

.team-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 2.5rem;
  margin-top: 4rem;
}

.team-member {
  background: white;
  padding: 2.5rem;
  border-radius: 1.5rem;
  text-align: center;
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
}

.team-member::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.team-member:hover::before {
  transform: scaleX(1);
}

.team-member:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(102, 126, 234, 0.15);
}

.member-photo {
  margin-bottom: 1.5rem;
}

.member-photo img {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #e2e8f0;
  transition: all 0.3s ease;
}

.team-member:hover .member-photo img {
  border-color: #667eea;
  box-shadow: 0 8px 16px rgba(102, 126, 234, 0.2);
}

.member-info h3 {
  font-size: 1.4rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 0.5rem;
  letter-spacing: -0.01em;
}

.member-title {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 500;
  margin-bottom: 1rem;
  font-size: 1rem;
}

.member-bio {
  color: #64748b;
  line-height: 1.6;
  font-size: 0.95rem;
  margin-bottom: 1.5rem;
}

.member-social {
  margin-top: 1rem;
}

.linkedin-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: #0077b5;
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
  padding: 0.75rem 1.25rem;
  border: 1px solid #0077b5;
  border-radius: 0.75rem;
  transition: all 0.3s ease;
  background: rgba(0, 119, 181, 0.05);
}

.linkedin-link:hover {
  background: #0077b5;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 119, 181, 0.3);
}

.linkedin-link svg {
  width: 16px;
  height: 16px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .team-container {
    padding: 1rem;
  }
  
  .team-content {
    padding: 2rem;
  }
  
  .team-content h1 {
    font-size: 2.25rem;
  }
  
  .team-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .team-content {
    padding: 1.5rem;
  }
  
  .team-content h1 {
    font-size: 2rem;
  }
  
  .team-member {
    padding: 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/TeamPage.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iHAAiH;AACnH;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6DAA6D;EAC7D,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Team Page Styles */\n.team-page {\n  min-height: 100vh;\n  background: #f8fafc;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;\n}\n\n.team-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.back-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: #3b82f6;\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin-bottom: 2rem;\n}\n\n.back-arrow {\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.back-button:hover {\n  background: #2563eb;\n  transform: translateY(-1px);\n}\n\n.team-content {\n  background: white;\n  border-radius: 12px;\n  padding: 3rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  border: 1px solid #e5e7eb;\n}\n\n.team-content h1 {\n  text-align: center;\n  font-size: 2.75rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, #1e293b 0%, #475569 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin-bottom: 1.5rem;\n  letter-spacing: -0.02em;\n}\n\n.team-subtitle {\n  text-align: center;\n  font-size: 1.2rem;\n  color: #64748b;\n  max-width: 600px;\n  margin: 0 auto 4rem;\n  line-height: 1.7;\n}\n\n.team-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 2.5rem;\n  margin-top: 4rem;\n}\n\n.team-member {\n  background: white;\n  padding: 2.5rem;\n  border-radius: 1.5rem;\n  text-align: center;\n  border: 1px solid #e2e8f0;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  position: relative;\n  overflow: hidden;\n}\n\n.team-member::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  transform: scaleX(0);\n  transition: transform 0.3s ease;\n}\n\n.team-member:hover::before {\n  transform: scaleX(1);\n}\n\n.team-member:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 20px 40px rgba(102, 126, 234, 0.15);\n}\n\n.member-photo {\n  margin-bottom: 1.5rem;\n}\n\n.member-photo img {\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 3px solid #e2e8f0;\n  transition: all 0.3s ease;\n}\n\n.team-member:hover .member-photo img {\n  border-color: #667eea;\n  box-shadow: 0 8px 16px rgba(102, 126, 234, 0.2);\n}\n\n.member-info h3 {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 0.5rem;\n  letter-spacing: -0.01em;\n}\n\n.member-title {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  font-weight: 500;\n  margin-bottom: 1rem;\n  font-size: 1rem;\n}\n\n.member-bio {\n  color: #64748b;\n  line-height: 1.6;\n  font-size: 0.95rem;\n  margin-bottom: 1.5rem;\n}\n\n.member-social {\n  margin-top: 1rem;\n}\n\n.linkedin-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #0077b5;\n  text-decoration: none;\n  font-size: 0.9rem;\n  font-weight: 500;\n  padding: 0.75rem 1.25rem;\n  border: 1px solid #0077b5;\n  border-radius: 0.75rem;\n  transition: all 0.3s ease;\n  background: rgba(0, 119, 181, 0.05);\n}\n\n.linkedin-link:hover {\n  background: #0077b5;\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 119, 181, 0.3);\n}\n\n.linkedin-link svg {\n  width: 16px;\n  height: 16px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .team-container {\n    padding: 1rem;\n  }\n  \n  .team-content {\n    padding: 2rem;\n  }\n  \n  .team-content h1 {\n    font-size: 2.25rem;\n  }\n  \n  .team-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .team-content {\n    padding: 1.5rem;\n  }\n  \n  .team-content h1 {\n    font-size: 2rem;\n  }\n  \n  .team-member {\n    padding: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
